import "./AddCustomerWidget.scss";
// import { motion } from "framer-motion";
import React from "react";
import Icon from "../../../assets/icons";
import primaryComponents from "../../primaryComponents";
import { Controller } from "react-hook-form";
import { useAddCustomerWidgetLogic } from "./AddCustomerWidgetLogic";
import { useCustomerWidgetValidation } from "./AddCustomerWidgetValidation";
import { DOB_DAYS, DOB_YEARS, MONTHS_OF_YEAR_FULL } from "../../../helpers";

const AddCustomerWidget = ({ closeWidget }) => {
  const {
    customerName,
    customerEmail,
    customerGender,
    customerPhoneNumber,
    dobDay,
    dobMonth,
    dobYear,
    isSubmitting,
    setDobDay,
    setDobMonth,
    setDobYear,
    setCustomerEmail,
    setCustomerGender,
    setCustomerName,
    setCustomerPhoneNumber,
    handleAddCustomer,
  } = useAddCustomerWidgetLogic({ closeWidget });

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors },
  } = useCustomerWidgetValidation({
    customerName,
    customerEmail,
    customerGender,
    customerPhoneNumber,
    dobDay,
    dobMonth,
    dobYear,
  });

  return (
    <div className="add-customers">
      <div className="add-customers__close" onClick={() => closeWidget(false)}>
        <img src={Icon.close} alt="" />
      </div>

      <div className="add-customers__desc">
        <h4 className="font-weight-semibold">Add Customer</h4>
        <p>Provide the following details about your customer.</p>
      </div>
      <form
        onSubmit={handleSubmit(handleAddCustomer)}
        className="add-customers__form"
        id="add-customer-form"
      >
        <Controller
          control={control}
          name="customerName"
          defaultValue={customerName}
          render={({ field: { onChange } }) => (
            <primaryComponents.InputField
              label="Name"
              isRequired={true}
              name="customerName"
              value={customerName}
              placeholder="Enter your customer’s name"
              onChange={({ target: { value } }) => {
                onChange(value);
                setCustomerName(value);
              }}
              onKeyUp={() => {
                errors.customerName !== undefined && trigger("customerName");
              }}
              errorMessage={errors.customerName}
            />
          )}
        />
        <Controller
          control={control}
          name="customerPhoneNumber"
          defaultValue={customerPhoneNumber}
          render={({ field: { onChange } }) => (
            <primaryComponents.PhoneNumberInputField
              label="Phone Number"
              isRequired={true}
              name="customerPhoneNumber"
              value={customerPhoneNumber}
              placeholder="Enter your customer’s phone number"
              onChange={({ target: { value } }) => {
                onChange(value);
                setCustomerPhoneNumber(value);
              }}
              onKeyUp={() => {
                errors.customerPhoneNumber !== undefined &&
                  trigger("customerPhoneNumber");
              }}
              errorMessage={errors.customerPhoneNumber}
            />
          )}
        />
        <Controller
          control={control}
          name="customerEmail"
          defaultValue={customerEmail}
          render={({ field: { onChange } }) => (
            <primaryComponents.InputField
              label="Email"
              name="customerEmail"
              value={customerEmail}
              isRequired={true}
              placeholder="Enter your customer’s email address"
              onChange={({ target: { value } }) => {
                onChange(value);
                setCustomerEmail(value);
              }}
              onKeyUp={() => {
                errors.customerEmail !== undefined && trigger("customerEmail");
              }}
              errorMessage={errors.customerEmail}
            />
          )}
        />

        <div>
          <label>Gender</label>
          <div className="form-gender__checkbox  add-customers__form--gender d-flex">
            <Controller
              control={control}
              name={"customerGender"}
              defaultValue={customerGender}
              render={({ field: { onChange } }) => (
                <primaryComponents.BoxedRadioInput
                  value={"MALE"}
                  name={"customerGender"}
                  setRadioValue={(value) => {
                    onChange(value);
                    setCustomerGender(value);
                  }}
                  isChecked={customerGender === "MALE"}
                  className="add-customers__form--gender-item"
                >
                  Male
                </primaryComponents.BoxedRadioInput>
              )}
            />
            <Controller
              control={control}
              name={"customerGender"}
              defaultValue={customerGender}
              render={({ field: { onChange } }) => (
                <primaryComponents.BoxedRadioInput
                  value={"FEMALE"}
                  name={"customerGender"}
                  setRadioValue={(value) => {
                    onChange(value);
                    setCustomerGender(value);
                  }}
                  isChecked={customerGender === "FEMALE"}
                  className="add-customers__form--gender-item"
                >
                  Female
                </primaryComponents.BoxedRadioInput>
              )}
            />
          </div>
        </div>
        {/* Date of Birth - Day / Month (required), Year (optional) */}
        <div>
          <label style={{ display: "block", marginBottom: "6px" }}>
            Date of Birth
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            {/* Day */}
            <Controller
              control={control}
              name="dobDay"
              defaultValue={dobDay}
              render={({ field: { onChange } }) => (
                <primaryComponents.SelectField
                  label="Day"
                  isRequired={true}
                  name="dobDay"
                  placeholder="DD"
                  value={dobDay}
                  options={DOB_DAYS}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    onChange(value);
                    setDobDay(value);
                  }}
                  errorMessage={errors.dobDay}
                />
              )}
            />
            {/* Month */}
            <Controller
              control={control}
              name="dobMonth"
              defaultValue={dobMonth}
              render={({ field: { onChange } }) => (
                <primaryComponents.SelectField
                  label="Month"
                  isRequired={true}
                  name="dobMonth"
                  placeholder="MM"
                  value={dobMonth}
                  options={MONTHS_OF_YEAR_FULL.map((name, i) => ({
                    id: i + 1,
                    name,
                  }))}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    onChange(value);
                    setDobMonth(value);
                  }}
                  errorMessage={errors.dobMonth}
                />
              )}
            />
            {/* Year (optional) */}
            <Controller
              control={control}
              name="dobYear"
              defaultValue={dobYear}
              render={({ field: { onChange } }) => (
                <primaryComponents.SelectField
                  label="Year"
                  name="dobYear"
                  placeholder="YYYY"
                  value={dobYear}
                  options={DOB_YEARS}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    onChange(value);
                    setDobYear(value);
                  }}
                  errorMessage={errors.dobYear}
                />
              )}
            />
          </div>
        </div>
      </form>
      <primaryComponents.Button
        isDisabled={isSubmitting}
        isLoading={isSubmitting}
        loadingText={"Adding customer..."}
        className="btn btn--primary"
        form="add-customer-form"
        type="submit"
      >
        Add Customer
      </primaryComponents.Button>
    </div>
  );
};

export default AddCustomerWidget;
